export default {
  key: "about",
  basePath: '/about',
  exclude: false,
}